<template>
    <v-container>
        <v-row text-center wrap>
            <v-col xs="12">
                <v-card>
                    <v-toolbar flat class="grey lighten-4">
                        <v-toolbar-title>Администраторы</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            v-if="user.root"
                            @click="createAdminPopup"
                            color="success"
                        >
                            Добавить
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-data-table
                            :headers="search.headers"
                            :items="search.data"
                            :loading="search.loading"
                        >
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td class="text-left">{{ item.id }}</td>
                                    <td class="text-left">{{ item.name }}</td>
                                    <td class="text-left">{{ item.email }}</td>
                                    <td class="text-left">
                                        <span v-if="item.status === 'active'" class="success--text">Активен</span>
                                        <span v-else class="error--text">Заблокирован</span>
                                    </td>
                                    <td class="text-left">
                                        <div class="d-inline-flex align-center">
                                            <v-icon
                                                v-if="user.root"
                                                small
                                                class="mr-2"
                                                @click="updateAdminPopup(item)"
                                            >
                                                mdi-pencil
                                            </v-icon>
                                            <v-icon
                                                v-if="user.root && item.status === 'active'"
                                                small
                                                class="mr-2"
                                                @click="updateAdminStatus(item, 'inactive')"
                                            >
                                                mdi-pause
                                            </v-icon>
                                            <v-icon
                                                v-if="user.root && item.status !== 'active'"
                                                small
                                                class="mr-2"
                                                @click="updateAdminStatus(item, 'active')"
                                            >
                                                mdi-play
                                            </v-icon>
                                            <v-icon
                                                v-if="user.root && !item.root"
                                                small
                                                @click="removeAdminPopup(item)"
                                            >
                                                mdi-delete
                                            </v-icon>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog
            v-if="create.show"
            v-model="create.show"
            max-width="500"
        >
            <v-card>
                <v-card-title class="headline">Новый администратор</v-card-title>
                <v-form
                    @submit.prevent="createAdmin"
                    autocomplete="off"
                >
                    <v-card-text>
                        <v-text-field
                            v-model="create.data.name"
                            :error-messages="create.errors.name"
                            name="name"
                            label="Имя"
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="create.data.email"
                            :error-messages="create.errors.email"
                            name="email"
                            label="Почта"
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="create.data.password"
                            :error-messages="create.errors.password"
                            name="password"
                            label="Пароль"
                            type="text">
                        </v-text-field>
                        <v-select
                            v-model="create.data.tasks"
                            :error-messages="create.errors.tasks"
                            :items="tasks"
                            :cache-items="true"
                            item-text="name"
                            item-value="id"
                            label="Видимость задач"
                        >
                        </v-select>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="create.show = false"
                            :disabled="create.progress"
                            text
                            color="error"
                        >
                            Отменить
                        </v-btn>
                        <v-btn
                            :loading="create.progress"
                            type="submit"
                            color="primary"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="remove.show"
            v-model="remove.show"
            max-width="600"
        >
            <v-card>
                <v-card-title class="headline">Удалить администратора {{ remove.data.name }}?</v-card-title>
                <v-card-text>
                    <p v-if="remove.errors.id.length" class="mt-5 mb-0 error--text">{{ remove.errors.id[0] }}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="remove.show = false"
                        :disabled="remove.progress"
                        color="red darken-1"
                        text
                    >
                        Отменить
                    </v-btn>
                    <v-btn
                        @click="removeAdmin"
                        :loading="remove.progress"
                        color="green darken-1"
                        text
                    >
                        Удалить
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="update.show"
            v-model="update.show"
            max-width="500"
        >
            <v-card>
                <v-card-title class="headline">Редактирование администратора</v-card-title>
                <v-form
                    @submit.prevent="updateAdmin"
                    autocomplete="off"
                >
                    <v-card-text>
                        <v-text-field
                            v-model="update.data.name"
                            :error-messages="update.errors.name"
                            name="name"
                            label="Имя"
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="update.data.email"
                            :error-messages="update.errors.email"
                            name="email"
                            label="Почта"
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="update.data.password"
                            :error-messages="update.errors.password"
                            name="password"
                            label="Пароль"
                            type="text">
                        </v-text-field>
                        <v-select
                            v-model="update.data.tasks"
                            :error-messages="update.errors.tasks"
                            :items="tasks"
                            :cache-items="true"
                            item-text="name"
                            item-value="id"
                            label="Видимость задач"
                        >
                        </v-select>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="update.show = false"
                            :disabled="update.progress"
                            text
                            color="error"
                        >
                            Отменить
                        </v-btn>
                        <v-btn
                            :loading="update.progress"
                            type="submit"
                            color="primary"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    name: "AdminController",
    data () {
        return {
            create: {
                data: {
                    name: '',
                    email: '',
                    password: '',
                    tasks: 'own',
                },
                errors: {
                    name: [],
                    email: [],
                    password: [],
                    tasks: [],
                },
                progress: false,
                show: false,
            },
            remove: {
                data: {
                    id: '',
                },
                errors: {
                    id: [],
                },
                progress: false,
                show: false,
            },
            search: {
                data: [],
                headers: [
                    {
                        text: 'ID',
                        value: 'id',
                    },
                    {
                        text: 'Имя',
                        value: 'Имя',
                    },
                    {
                        text: 'Почта',
                        value: 'email',
                    },
                    {
                        text: 'Статус',
                        value: 'status',
                    },
                    {
                        text: 'Действия',
                        value: 'id',
                    },
                ],
                loading: true,
            },
            tasks: [
                {id: 'own', name: 'Только свои'},
                {id: 'all', name: 'Все'},
            ],
            update: {
                data: {
                    id: 0,
                    name: '',
                    email: '',
                    password: '',
                    tasks: '',
                },
                errors: {
                    id: [],
                    name: [],
                    email: [],
                    password: [],
                    tasks: [],
                },
                progress: false,
                show: false,
            },
        }
    },
    computed: {
        user: function () {
            return this.$store.getters.user
        },
    },
    created () {
        this.searchAdmins()
    },
    methods: {
        createAdmin () {
            this.create.progress = true

            this.create.errors.name = []
            this.create.errors.email = []
            this.create.errors.password = []
            this.create.errors.tasks = []

            this.$axios.post('/manager/admin/create', this.create.data)
                .then((res) => {
                    if (res.data.success) {
                        this.create.show = false
                        this.create.data.name = ''
                        this.create.data.email = ''
                        this.create.data.password = ''
                        this.create.data.tasks = 'own'
                    } else {
                        this.create.errors.name = res.data.errors.name || []
                        this.create.errors.email = res.data.errors.email || []
                        this.create.errors.password = res.data.errors.password || []
                        this.create.errors.tasks = res.data.errors.tasks || []
                    }

                    this.create.progress = false

                    this.searchAdmins()
                })
                .catch(() => {
                    this.create.progress = false
                })
        },

        createAdminPopup () {
            this.create.show = true
        },

        removeAdmin () {
            this.remove.progress = true

            this.$axios.post('/manager/admin/remove', this.remove.data)
                .then((res) => {
                    if (res.data.success) {
                        this.remove.show = false
                        this.remove.data.id = 0
                        this.remove.data.name = ''

                        this.searchAdmins()
                    } else {
                        this.remove.errors.id = res.data.errors.id || []
                    }

                    this.remove.progress = false
                })
                .catch(() => {
                    this.remove.progress = false
                })
        },

        removeAdminPopup (admin) {
            this.remove.data.id = admin.id
            this.remove.data.name = admin.name
            this.remove.show = true
        },

        searchAdmins () {
            this.search.loading = true

            this.$axios.post('/manager/admin/search')
                .then(res => {
                    if (res.data.success) {
                        this.search.data = res.data.data
                    }

                    this.search.loading = false
                })
                .catch(() => {
                    this.search.loading = false
                })
        },

        updateAdmin () {
            this.update.progress = true

            this.update.errors.id = []
            this.update.errors.name = []
            this.update.errors.email = []
            this.update.errors.password = []
            this.update.errors.tasks = []

            this.$axios.post('/manager/admin/update', this.update.data)
                .then((res) => {
                    if (res.data.success) {
                        this.update.show = false
                        this.update.data.id = 0
                        this.update.data.name = ''
                        this.update.data.email = ''
                        this.update.data.password = ''
                        this.update.data.tasks = 'own'
                    } else {
                        this.update.errors.id = res.data.errors.id || []
                        this.update.errors.name = res.data.errors.name || []
                        this.update.errors.email = res.data.errors.email || []
                        this.update.errors.password = res.data.errors.password || []
                        this.update.errors.tasks = res.data.errors.tasks || []
                    }

                    this.update.progress = false

                    this.searchAdmins()
                })
                .catch(() => {
                    this.update.progress = false
                })
        },

        updateAdminPopup (admin) {
            this.update.data.id = admin.id
            this.update.data.name = admin.name
            this.update.data.email = admin.email
            this.update.data.password = ''
            this.update.data.tasks = admin.tasks
            this.update.show = true
        },

        updateAdminStatus (admin, status) {
            this.$axios.post('/manager/admin/status', {id: admin.id, status: status})
                .then(() => {
                    this.searchAdmins()
                })
                .catch(() => {
                    this.searchAdmins()
                })
        },
    },
}
</script>
